import { environment } from 'src/environments/environment';

export const OPEN_PAY = {
  id: environment.openpayId,
  apiKey: environment.openpayKey,
  isDev: !environment.production,
};
